import React from 'react';
import { TextField } from '@material-ui/core';

const ReduxTextField = ({input, meta, ...props}) => {
    return <TextField {...props} {...input}
        error={meta.touched && meta.error}
        helperText={(meta.touched && meta.error) ? meta.error : props.helperText} />
};

export default ReduxTextField;


// WEBPACK FOOTER //
// ./src/common/ReduxTextField.js